import { useQuery } from '@tanstack/react-query';
import { PkCard } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo } from 'react';

import { useArticleLinkRule } from '@hooks/useLinkRule';
import { getWebContainerQuery } from '@queries/editorial';
import { withErrorBoundary } from '@shared/ErrorBoundary';
import { useTranslateFn } from '@shared/Translate';
import { competitionCode } from '@utilities/WindowContext';

import * as styles from './styles.module.scss';

const WEB_CONTAINER = `${competitionCode}.TICKETS.GOODTOKNOW`.toUpperCase();

const GoodToKnow = () => {
  const t = useTranslateFn();
  const { data: articles } = useQuery(getWebContainerQuery(WEB_CONTAINER));

  if (!articles?.length) return null;

  return (
    <div className={clsx(styles.wrapper, 'pk-container', 'pk-py--l pk-py-md--xl2')}>
      <h2 className='pk-font--comp-bold pk-col pk-col--span-12 pk-text--text-01 pk-font-size--xl pk-font-size-sm--xl2'>
        {t('good_to_know')}
      </h2>
      {articles.map((article) => (
        <Article key={article.id} article={article} />
      ))}
    </div>
  );
};

const Article = ({ article }) => {
  const href = useArticleLinkRule(article.id);

  return (
    <div className='pk-col pk-col--span-00-4'>
      <a href={href} title={article.title}>
        <PkCard className={styles.articleCard}>
          <div slot='heading'>
            <img
              className={styles.img}
              src={article.imageUrl}
              title={article.title}
              alt={article.title}
              loading='lazy'
            />
          </div>
          <div slot='body'>
            <div className={clsx(styles.articleCardTitle, 'pk-font--base-semibold pk-text--text-01 pk-font-size--l')}>
              {article.title}
            </div>
            <div className={clsx(styles.articleCardDescription, 'pk-m--0 pk-font-size--m pk-text--text-01 pk-mt--xs')}>
              {article.description}
            </div>
          </div>
        </PkCard>
      </a>
    </div>
  );
};

export default withErrorBoundary(memo(GoodToKnow));
